import React, { FC } from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { NavLink } from '@/shared/navigation';
import { isEmpty } from '@/libs';
import { closeMenuDrawer } from '@components/Navbar/utils';

const StyledNavLink = styled(NavLink)`
  min-height: 40px;
  width: 100%;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none !important;
  background-color: transparent;
  border-radius: 4px;
  user-select: none;
  position: relative;

  background: transparent;
  margin-bottom: 4px;
  @media screen and (max-width: 768px) {
    min-height: 48px;
    padding: 0 14px;
    > span:first-child {
      font-size: 28px;
    }
  }

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: var(--green-6);
  }

  span {
    color: var(--gray-7) !important;
    justify-self: start;
  }
  &.sidebar-lint-active {
    &::after {
      content: '';
    }
    background: #dff9e4;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    span {
      color: var(--green-6) !important;
    }
  }
  &:hover {
    background: var(--green-2);
  }
  &:hover > span {
    color: var(--gray-9) !important;
  }
`;

const Icon = styled.span`
  font-size: 24px;
  color: var(--gray-7);
  @media screen and (max-width: 768px) {
    font-size: 28px;
  }
`;

const Counter = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: #fff;
  background-color: var(--green-6);
  cursor: default;
`;

interface Props {
  userTipName?: string;
  iconClass: string;
  label: string;
  path: string;
  href?: string;
  exact?: boolean;
  count?: number;
}

const Text = styled(Typography.Text)`
  color: var(--gray-7) !important;
  font: var(--font-normal-14) !important;
  @media screen and (max-width: 768px) {
    font: var(--font-normal-18) !important;
  }
`;

export const NavLinkItem: FC<Props> = ({ iconClass, label, path, href, exact, userTipName, count }) => {
  const linkPath = href ? { pathname: href } : path;

  return (
    <StyledNavLink
      to={linkPath}
      exact={exact}
      target={href ? '_blank' : '_self'}
      shouldParseLocation={isEmpty(href)}
      activeClassName="sidebar-lint-active"
      onClick={() => closeMenuDrawer()}
    >
      <Icon className={iconClass} />
      <Text>{label}</Text>
      {!!count && <Counter>{count}</Counter>}
    </StyledNavLink>
  );
};
